import { t } from "i18next";
import { View, Views } from "react-big-calendar";
import { SelectInputData } from "../../../../../components/deprecated/SelectInputField/SelectInputField";

import BookingUnitData, { BookingGrouping } from "../../../Property/Booking/BookingUnitData";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";
import { InputElementContext } from "../DataObjectField";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataBookingUnitField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<
  BookingUnitData,
  FirebaseDataType
> {
  override encode = (value: BookingUnitData) => value.id;
  override convertValueToSelectInput(value: BookingUnitData): SelectInputData {
    return new SelectInputData(value.id, value.name);
  }
  getValueForKey(key: string): BookingUnitData | undefined {
    for (const property of LocalData.currentUser.properties) {
      const bookingUnit = property.bookingUnits.getData(key);
      if (bookingUnit) return bookingUnit;
    }
    return undefined;
  }
  getOptions(context?: InputElementContext | undefined): FirebaseDataSelectFieldOption[] {
    return (LocalData.properties.getData(context?.propertyID)?.bookingUnits.documents ?? []).map((u) => ({ key: u.id, label: u.name }));
  }
  loadAllDatas(context?: InputElementContext | undefined): Promise<any> {
    const property = LocalData.properties.getData(context?.propertyID);
    if (property && !property.bookingUnits.loaded) {
      return property.bookingUnits.loadWithPromise();
    }
    return Promise.resolve();
  }

  override isValueValid = (value: any): boolean => {
    return value instanceof BookingUnitData;
  };
}

export class FirebaseDataCalendarViewField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<View, FirebaseDataType> {
  encode = (value: View) => value;
  override convertValueToSelectInput(value: View): SelectInputData {
    return new SelectInputData(value, this.getNames()[value] ?? value);
  }
  getValueForKey(key: string): View | undefined {
    return key as View;
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return [Views.DAY, Views.WEEK, Views.WORK_WEEK, Views.MONTH, Views.AGENDA].map((view) => ({ key: view, label: this.getNames()[view] }));
  }

  getNames(): { [key: string]: string } {
    return {
      [Views.DAY]: t("main.day"),
      [Views.WEEK]: t("main.week"),
      [Views.WORK_WEEK]: t("main.workWeek"),
      [Views.MONTH]: t("main.month"),
      [Views.AGENDA]: t("main.agenda"),
    };
  }
  override isValueValid = (value: any): boolean => {
    return typeof value === "string" && Object.values(Views).includes(value as any);
  };
}

export class FirebaseDataBookingGroupingField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<
  BookingGrouping,
  FirebaseDataType
> {
  override encode = (value: BookingGrouping) => value;

  override convertValueToSelectInput(value: BookingGrouping): SelectInputData {
    return new SelectInputData(value, this.getNames()[value] ?? value);
  }
  getValueForKey(key: string): BookingGrouping | undefined {
    return key as BookingGrouping;
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return ["individually", "unit"].map((view) => ({ key: view, label: this.getNames()[view] }));
  }

  getNames(): { [key: string]: string } {
    return {
      individually: t("main.individually"),
      unit: t("main.unit"),
    };
  }

  override isValueValid = (value: any): boolean => {
    return this.getOptions()
      .map((o) => o.key)
      .includes(value);
  };
}
